require('./types');

module.exports = {
  DestinationBankAccountModel: require('./DestinationBankAccount')
};
